import { ThisConnector } from '../../../../api/connector'
import { BaseApiResponse } from '../../../../api/shared'

export interface AddIpToBlockListArgs {
  organizationUuid: string
  ip: string
  name: string
  trusted: boolean
  expiration: number
  expirationTime?: Date
}

export async function addIpToBlockList(
  this: ThisConnector,
  {
    organizationUuid,
    ip,
    name,
    trusted,
    expiration,
    expirationTime
  }: AddIpToBlockListArgs
): Promise<BaseApiResponse> {
  const { messages, success } = await this.connector.put<BaseApiResponse>(
    `${organizationUuid}/ip?expand=skip_links`,
    {
      ip,
      name,
      trusted,
      expiration,
      expiration_time: expirationTime
    }
  )

  return { messages, success }
}
